import { createAction, props } from '@ngrx/store';
import {
  FinancialStatement,
  FinancialStatementCreate,
} from '../../models/financial-statement.model';

// Load Financial Statements
export const loadFinancialStatements = createAction(
  '[Financial Statements] Load Financial Statements',
  props<{ stockId?: string; statementType?: string; filter?: string; fromDate?: string; toDate?: string }>()
);
export const loadFinancialStatementsSuccess = createAction(
  '[Financial Statements] Load Financial Statements Success',
  props<{ financialStatements: FinancialStatement[]; statementType: string }>()
);
export const loadFinancialStatementsFailure = createAction(
  '[Financial Statements] Load Financial Statements Failure',
  props<{ error: any; statementType: string }>()
);

// Load Single Financial Statement
export const loadFinancialStatement = createAction(
  '[Financial Statements] Load Financial Statement',
  props<{ id: string; statementType: string }>()
);
export const loadFinancialStatementSuccess = createAction(
  '[Financial Statements] Load Financial Statement Success',
  props<{ financialStatement: FinancialStatement; statementType: string }>()
);
export const loadFinancialStatementFailure = createAction(
  '[Financial Statements] Load Financial Statement Failure',
  props<{ error: any; statementType: string }>()
);

// Create Financial Statement
export const createFinancialStatement = createAction(
  '[Financial Statements] Create Financial Statement',
  props<{ financialStatement: FinancialStatementCreate; statementType: string }>()
);
export const createFinancialStatementSuccess = createAction(
  '[Financial Statements] Create Financial Statement Success',
  props<{ financialStatement: FinancialStatementCreate; statementType: string }>()
);
export const createFinancialStatementFailure = createAction(
  '[Financial Statements] Create Financial Statement Failure',
  props<{ error: any; statementType: string }>()
);

// Update Financial Statement
export const updateFinancialStatement = createAction(
  '[Financial Statements] Update Financial Statement',
  props<{ id: string; financialStatement: FinancialStatementCreate; statementType: string }>()
);
export const updateFinancialStatementSuccess = createAction(
  '[Financial Statements] Update Financial Statement Success',
  props<{ financialStatement: FinancialStatement; statementType: string }>()
);
export const updateFinancialStatementFailure = createAction(
  '[Financial Statements] Update Financial Statement Failure',
  props<{ error: any; statementType: string }>()
);

// Delete Financial Statement
export const deleteFinancialStatement = createAction(
  '[Financial Statements] Delete Financial Statement',
  props<{ id: string; statementType: string }>()
);
export const deleteFinancialStatementSuccess = createAction(
  '[Financial Statements] Delete Financial Statement Success',
  props<{ id: string; statementType: string }>()
);
export const deleteFinancialStatementFailure = createAction(
  '[Financial Statements] Delete Financial Statement Failure',
  props<{ error: any; statementType: string }>()
);
